module.exports = __webpack_public_path__ + "img/立足深圳，服务全球 2@2x.2001d601.png";